import React from 'react';
import BiButton from '../../../biLogger/Components/BiButton';
import BiLink from '../../../biLogger/Components/BiLink';
import Button from '../../../Button';
var ActionBarButtonComponent = function (_a) {
    var children = _a.children, view = _a.view, href = _a.href, className = _a.className, dataHook = _a.dataHook, biData = _a.biData, isDisabled = _a.isDisabled, isDisabledByPanel = _a.isDisabledByPanel, isDownload = _a.isDownload, onClick = _a.onClick, ariaLabel = _a["aria-label"];
    if (view) {
        return (React.createElement(Button, { className: className, href: href, onClick: onClick, biData: biData, dataHook: dataHook, view: view, disabled: isDisabled, "aria-label": ariaLabel }, children));
    }
    if (href) {
        if (isDisabledByPanel || isDisabled) {
            return (React.createElement("span", { className: className, "data-hook": dataHook }, children));
        }
        return (React.createElement(BiLink, { href: href, onClick: onClick, biData: biData, "data-hook": dataHook, download: isDownload, target: isDownload ? '_blank' : undefined, className: className, "aria-label": ariaLabel }, children));
    }
    if (!onClick) {
        return (React.createElement("span", { className: className, "data-hook": dataHook }, children));
    }
    return (React.createElement(BiButton, { className: className, onClick: onClick, biData: biData, disabled: isDisabled || isDisabledByPanel, "data-hook": dataHook, "aria-label": ariaLabel }, children));
};
ActionBarButtonComponent.displayName = 'ActionBarButtonComponent';
export default ActionBarButtonComponent;
//# sourceMappingURL=ActionBarButtonComponent.js.map